import React, { useMemo } from 'react'
import { makeStyles, Theme, createStyles, } from '@material-ui/core/styles';
import { Typography, Stepper, Step, StepLabel, Button, CircularProgress } from '@material-ui/core';
import { green } from '@material-ui/core/colors';


interface Prop {
  activeStep: number,
  handleNext: () => void,
  handleBack: () => void,
  reqbasicItem: {
    custmNo: boolean; custmDepNo: boolean; keiyakuNo: boolean; orderNo: boolean; keiyakuClsCd: boolean; keiyakuStartTs: boolean; renewalMonth: boolean; keiyakuPersonCd: boolean; keiyakuDeposit: boolean; totalPrice: boolean; machineSettingZipCd: boolean; machineSettingAddress: boolean;
  },
  checkbasicItem: { keiyakuNo: boolean; orderNo: boolean; keiyakuDeposit: boolean; totalPrice: boolean; incidentDeposit: boolean; visitCount: boolean; incidentCount: boolean; machineSettingZipCd: boolean; },
  reqinvoiceItem: {
    demandZipCd: boolean; demandAddress: boolean; demandCompanyName: boolean; demandPersonName: boolean; demandMonth: boolean; actionSeDeptCd: boolean;
  },
  checkinvoiceItem: { monthlyPrice: boolean; monthlyPrice2: boolean; demandZipCd: boolean; },
  onSubmit: () => void,
  loading: boolean,
  errMsg: string,
}

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      width: '100%',
    },
    backButton: {
      marginRight: theme.spacing(1),
    },
    instructions: {
      marginTop: theme.spacing(1),
      marginBottom: theme.spacing(1),
    },
    wrapper: {
      position: 'relative',
    },
    buttonProgress: {
      color: green[500],
      position: 'absolute',
      top: '50%',
      marginTop: -12,
      marginLeft: -52,
    },
  }),
);

const ContractStepper: React.FC<Prop> = (props) => {
  const classes = useStyles();
  const { activeStep, handleBack, handleNext, checkbasicItem, reqbasicItem, checkinvoiceItem, reqinvoiceItem, onSubmit, loading, errMsg } = props
  const getSteps = useMemo(() => {
    return ['契約基本情報', '契約詳細情報', '請求情報'];
  }, [])

  const errorBasicCheck = useMemo(() => {
    const reqbasicList = Object.entries(reqbasicItem).map(([key, value]) => (value))
    const checkbasicList = Object.entries(checkbasicItem).map(([key, value]) => {
      if (key === 'keiyakuNo') {
        return false
      } else {
        return value
      }
    })
    const concatbasicList = reqbasicList.concat(checkbasicList)
    return concatbasicList.includes(true)
  }, [checkbasicItem, reqbasicItem])

  const errorAllCheck = useMemo(() => {
    const reqinvoiceList = Object.entries(reqinvoiceItem).map(([key, value]) => (value))
    const checkinvoiceList = Object.entries(checkinvoiceItem).map(([key, value]) => (value))
    const concatallList = reqinvoiceList.concat(checkinvoiceList).concat([errorBasicCheck])
    return concatallList.includes(true)
  }, [errorBasicCheck, checkinvoiceItem, reqinvoiceItem])


  return (
    <div className={classes.root}>
      <Stepper activeStep={activeStep} style={{ padding: '4px 10px' }}>
        {getSteps.map((label) => (
          <Step key={label}>
            <StepLabel>{label}</StepLabel>
          </Step>
        ))}
      </Stepper>
      <div>
        {activeStep === getSteps.length ? (
          <div className={classes.wrapper}>
            <Button onClick={handleBack} className={classes.backButton} size='small' disabled={loading}>戻る</Button>
            <Button className={classes.backButton} onClick={() => onSubmit()} variant="contained" color="primary" size='small' disabled={errorAllCheck ? true : loading} >登録</Button>
            {errMsg && <Typography color="error" variant="caption" style={{ marginLeft: '4px' }}>{`${errMsg}契約番号を修正してください。`}</Typography>}
            {loading && <CircularProgress size={24} className={classes.buttonProgress} />}
          </div>
        ) : (
          <div>
            <Button disabled={activeStep === 0} onClick={handleBack} size='small' className={classes.backButton}>戻る</Button>
            {activeStep === getSteps.length - 1 ?
              <React.Fragment>
                <Button variant="outlined" color="primary" size='small' onClick={handleNext} disabled={errorAllCheck}>
                  登録
                </Button>
                {errorAllCheck ? <Typography color="error" variant="caption" style={{ marginLeft: '4px' }}>エラー項目があります</Typography> : checkbasicItem.keiyakuNo && <Typography color="error" variant="caption" style={{ marginLeft: '4px' }}>契約書番号が不正です</Typography>}
              </React.Fragment> :
              <React.Fragment>
                <Button variant="outlined" color="primary" size='small' onClick={handleNext} disabled={errorBasicCheck}>
                  次へ
              </Button>
                {errorBasicCheck ? <Typography color="error" variant="caption" style={{ marginLeft: '4px' }}>エラー項目があります</Typography> : checkbasicItem.keiyakuNo && <Typography color="error" variant="caption" style={{ marginLeft: '4px' }}>契約書番号が不正です</Typography>}
              </React.Fragment>
            }
          </div>
        )}
      </div>
    </div>
  );
}

export default ContractStepper
